import { withNamespaces } from 'react-i18next';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Alert,
    Spinner
} from 'reactstrap';
import { SubscriptionsStatues } from 'src/common/constants';

const RequestCancellationModal = ({
    t,
    isOpen,
    toggle,
    subscription,
    onConfirm,
    isLoading = false
}) => {
    const status = SubscriptionsStatues[subscription?.status];

    return (
        <Modal
            isOpen={isOpen}
            toggle={isLoading ? undefined : toggle}
            centered
        >
            <ModalHeader toggle={isLoading ? undefined : toggle}>
                {t('Request Subscription Cancellation')}
            </ModalHeader>

            <ModalBody>
                <p>
                    {t('Are you sure you want to request cancellation of this subscription?')}
                </p>

                <div className="border rounded p-3 bg-light mb-3">
                    <div>
                        <strong>{t('Subscription ID')}:</strong> #{subscription?.id}
                    </div>

                    <div className="mt-2">
                        <strong>{t('Current Status')}:</strong>{' '}
                        {t(status ? status.title : subscription?.status)}
                    </div>
                </div>

                <Alert color="warning" className="mb-0">
                    {t('The subscription will not be cancelled immediately.')}
                    {t('Its status will be changed to {{status}}', {
                        status: ''
                    })}{' '}
                    <strong>{t('Pending Cancellation')}</strong>{' '}
                    {t('and a cancellation request will be submitted for review.')}
                </Alert>
            </ModalBody>

            <ModalFooter>
                <Button
                    color="light"
                    onClick={toggle}
                    disabled={isLoading}
                >
                    {t('Keep Subscription')}
                </Button>

                <Button
                    color="warning"
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <Spinner size="sm" className='me-1' />
                            {t('Submitting')}...
                        </>
                    ) : (
                        <>
                            <i className="ri-close-circle-line me-1 font-size-18 align-middle" />
                            {t('Request Cancellation')}
                        </>
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    RequestCancellationModal
);